import { Component, OnInit } from '@angular/core';
import { calculateAgeWithTimezone, calculateAge } from '../../../util/age-util';
import * as moment from 'moment-timezone';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { TimeZoneUtils } from 'src/app/util/TimeZoneUtils';
import { RegUser } from '../../basic-reg/RegUser';
import { CommunicationConstants } from 'src/app/constants/CommunicationConstants';
import { CommonUtil } from 'src/app/util/CommonUtil';
import { ContactTimeComponent } from '@modal/contact-time/contact-time.component';

@Component({
  selector: 'app-profile-details-new',
  templateUrl: './profile-details-new.component.html',
  styleUrls: ['./profile-details-new.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ]
})
export class ProfileDetailsNewComponent implements OnInit {
  age: number | null = null;
  myUser: any;
  user: any;
  userContact: any;
  loggedInUser: RegUser = new RegUser();

  editEnabled: boolean = false;
  addEnabled: boolean = false;
  isSearchResult: boolean = false;
  viewTimeSlot: boolean = false;
  errorMessage: string = '';
  requestPath: string;

  selectedTab: string = "basic";

  userPreferredTime: string[] = [];
  userPreferredChannel: { id: number; name: string; checked: boolean }[] = [];
  myPreferredTime: string[] = [];
  myPreferredChannel: { id: number; name: string; checked: boolean }[] = [];
  userStartTime: string = '';
  userEndTime: string = '';
  myStartTime: string = '';
  myEndTime: string = '';
  senderCategory: string = '';
  recieverCategory: string = '';

  constructor(public global: Globals,
    public router: Router,
    public authService: AuthServiceService,
    private loader: LoaderService,
    public modlCtrl: ModalController,
    private modalCtrl: ModalController,
    public atrCtrl: AlertController) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit() {
    const nav = this.router.getCurrentNavigation();
    if (!nav || this.global.isEmpty(nav.extras.state)) {
      this.router.navigate(['dashboard']);
      return;
    }
    const state = nav && nav.extras && nav.extras.state ? nav.extras.state : {};
    this.editEnabled = state['editEnabled'] ?? false;
    this.addEnabled = state['addEnabled'] ?? false;
    this.myUser = state['user'] ?? null;
    this.isSearchResult = state['isSearchResult'] ?? false;
    this.userContact = state['userContact'] ?? null;
    this.viewTimeSlot = state['viewTimeSlot'] ?? false;
    this.user = this.userContact.contactUser;
    this.loggedInUser = this.authService.getLoggedInUser();
    // Calculate age (with timezone if available)
    if (this.user && this.user.birthDate && this.loggedInUser.timeZone) {
      this.age = calculateAgeWithTimezone(this.user.birthDate, this.loggedInUser.timeZone);
    } else if (this.user && this.user.birthDate) {
      this.age = calculateAge(this.user.birthDate);
    }

    // ...existing code...
  }

  getMaskedEmail(email: string): string {
    return CommonUtil.getMaskedEmail(email);
  }

  getMaskedPhone(phone: string): string {
    return CommonUtil.getMaskedPhone(phone);
  }

  ionViewDidEnter() {
    this.loggedInUser = this.authService.getLoggedInUser();
    this.loggedInUser.imageUrl = this.authService.getProfilePicture() as string;
    this.changeTab('basic');
    this.preferances();
  }

  changeTab(tabName: string) {
    this.selectedTab = tabName;
  }

  preferances() {
    // Loggedin user is sender
    var userPreferredTime;
    var myPreferredTime;
    var userPreferredChannel;
    var myPreferredChannel;
    if (this.userContact.ownerId == this.myUser.id) {
      userPreferredChannel = this.userContact.recieverCommChanel?.split(",");
      userPreferredTime = this.userContact.recieverPrefTime?.split(",");
      this.userStartTime = this.userContact.recieverStartTime;
      this.userEndTime = this.userContact.recieverEndTime;
      this.recieverCategory = this.userContact.recieverCategory;

      myPreferredChannel = this.userContact.senderCommChanel?.split(",");
      myPreferredTime = this.userContact.senderPrefTime?.split(",");
      this.myStartTime = this.userContact.senderStartTime;
      this.myEndTime = this.userContact.senderEndTime;
      this.senderCategory = this.userContact.senderCategory;
    } else {
      // Loggedin user is reciever
      myPreferredChannel = this.userContact.recieverCommChanel?.split(",");
      myPreferredTime = this.userContact.recieverPrefTime?.split(",");
      this.myStartTime = this.userContact.recieverStartTime;
      this.myEndTime = this.userContact.recieverEndTime;
      this.senderCategory = this.userContact.recieverCategory;

      userPreferredChannel = this.userContact.senderCommChanel?.split(",");
      userPreferredTime = this.userContact.senderPrefTime?.split(",");
      this.userStartTime = this.userContact.senderStartTime;
      this.userEndTime = this.userContact.senderEndTime;
      this.recieverCategory = this.userContact.senderCategory;
    }

    if (!this.global.isEmpty(userPreferredTime) || !this.global.isEmpty(myPreferredTime)) {
      var convertedUserPrefTime;
      var convertedMyPreferredTime;
      if (!this.global.isEmpty(userPreferredTime) && userPreferredTime != "All") {
        convertedUserPrefTime = this.getConvertedTimeList(userPreferredTime);
      }
      if (!this.global.isEmpty(myPreferredTime && myPreferredTime != "All")) {
        convertedMyPreferredTime = this.getConvertedTimeList(myPreferredTime);
      }

      if (userPreferredTime == "All") {
        this.userPreferredTime.push("Anytime");
      } else if (convertedUserPrefTime) {
        for (let prefTime of convertedUserPrefTime as string[])
          this.userPreferredTime.push(prefTime);
      }
      if (myPreferredTime == "All") {
        this.myPreferredTime.push("Anytime");
      } else if (convertedMyPreferredTime) {
        for (let prefTime of convertedMyPreferredTime as string[])
          this.myPreferredTime.push(prefTime);
      }
    }
    if (!this.global.isEmpty(userPreferredChannel) || !this.global.isEmpty(myPreferredChannel)) {
      for (var commType of this.communicationTypes) {
        if (userPreferredChannel?.includes(commType.id + "")) {
          this.userPreferredChannel.push(commType);
        }
      }
      for (var commType of this.communicationTypes) {
        if (myPreferredChannel?.includes(commType.id + "")) {
          this.myPreferredChannel.push(commType);
        }
      }
    }

    if (!this.global.isEmpty(this.myStartTime)) {
      this.myStartTime = this.changeTime24To12Format(TimeZoneUtils.convertUTCToCurrentTime(this.myStartTime, this.myUser.timeZone));
      this.myEndTime = this.changeTime24To12Format(TimeZoneUtils.convertUTCToCurrentTime(this.myEndTime, this.myUser.timeZone));
    }
    if (!this.global.isEmpty(this.userStartTime)) {
      this.userStartTime = this.changeTime24To12Format(TimeZoneUtils.convertUTCToCurrentTime(this.userStartTime, this.myUser.timeZone));
      this.userEndTime = this.changeTime24To12Format(TimeZoneUtils.convertUTCToCurrentTime(this.userEndTime, this.myUser.timeZone));
    }
    // console.log("userPreferredTime: " + JSON.stringify(this.userPreferredTime));
    // console.log("myPreferredTime: " + JSON.stringify(this.myPreferredTime));
    // console.log("userPreferredChannel: " + JSON.stringify(this.userPreferredChannel));
    // console.log("myPreferredChannel: " + JSON.stringify(this.myPreferredChannel));
    // console.log("userStartTime: " + this.userStartTime);
    // console.log("userEndTime: " + this.userEndTime);
    // console.log("myStartTime: " + this.myStartTime);
    // console.log("myStartTime: " + this.myEndTime);
  }

  convertUtcToUserTime(utcTime: string) {
    let splittedData = utcTime.split("-");
    if (splittedData.length != 2) {
      console.log("Invalid time range: " + utcTime);
      return utcTime;
    }
    return TimeZoneUtils.convertUTCToCurrentTime(splittedData[0], this.myUser.timeZone) + "-" + TimeZoneUtils.convertUTCToCurrentTime(splittedData[1], this.myUser.timeZone);
  }

  getConvertedTimeList(timeList: any) {
    let list: any[] = [];
    timeList.forEach((timeSlot: any) => {
      list.push(this.convertUtcToUserTime(timeSlot));
    });
    return list;
  }

  changeTime24To12Format(timeIn24Format: string) {
    let result = "";
    // Split slots
    var slotSplit = timeIn24Format.split("-");
    for (let splitSlot of slotSplit) {
      // Split Time
      var timeSplit = splitSlot.split(" ");
      // Split Hour and Minutes
      var hourMinSplit = timeSplit[0].split(":");
      if (parseInt(hourMinSplit[0]) > 12) {
        result += (parseInt(hourMinSplit[0]) - 12);
        result += ":";
        result += hourMinSplit[1];
        result += " PM";
      } else {
        result += splitSlot;
      }
      result += "-";
    }
    return result.substring(0, result.length - 1);
  }

  editMyPref() {
    this.openSettingModal(this.userContact);
  }

  async openSettingModal(userData: any) {
    const modal = await this.modalCtrl.create({
      component: ContactTimeComponent,
      componentProps: {
        user: userData
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      // this.router.navigateByUrl("dashboard");
    });

    modal.present();
  }

  async dismiss(data: any) {
    this.modalCtrl.dismiss(data);
  }

  timeSlotsCol1 = CommunicationConstants.timeSlotsCol1;
  timeSlotsCol2 = CommunicationConstants.timeSlotsCol2;
  communicationTypes = CommunicationConstants.communicationTypes;

}
